// t515 · B-2248 · ¿ME LLEGA ESTE AVISO POR ESTE CANAL? Para los avisos que pinta la propia pantalla (el aviso flotante del
// chat del equipo, el de una conversación derivada a tu bandeja, el sonido del modo doctor): lo que la clínica tiene
// configurado en Notificaciones → Configurar y lo que la persona se ha quitado en su Perfil, tal como lo devuelve
// GET /api/notif-config/mias (routes/notifConfig.js). Puro: sin React ni servidor (lo cargan de verdad las guardias).
//
// SIN DATOS, COMO SIEMPRE: si aún no ha llegado la respuesta, si el servidor no tiene la configuración activada o si la
// respuesta no tiene la forma esperada, contesta que sí (el aviso sale como hasta hoy). Solo dice que no cuando la clínica
// lo tiene apagado (o sin ese canal) o la persona se lo ha quitado.
export function meLlegaDe(datos, clave, canal) {
  if (!datos || datos.activado !== true || !Array.isArray(datos.grupos)) return true
  let tipo = null
  for (const g of datos.grupos) {
    for (const t of (g && Array.isArray(g.tipos) ? g.tipos : [])) if (t && t.clave === clave) tipo = t
  }
  // La lista trae los tipos encendidos con algún canal: si no está, la clínica lo tiene apagado.
  if (!tipo) return false
  const canales = Array.isArray(tipo.canales) ? tipo.canales : []
  if (!canales.includes(canal)) return false
  const apagados = Array.isArray(tipo.apagados) ? tipo.apagados : []
  return !apagados.includes(canal)
}

// La consulta compartida (misma clave en todas las pantallas, para que sea una sola petición).
export const CLAVE_MIS_AVISOS = ['notif-config-mias']
export const RUTA_MIS_AVISOS = '/notif-config/mias'
